import React from 'react';
// import logo from './logo.svg';
import './App.css';
import { RouteComponentProps } from 'react-router-dom'
import { Route } from 'react-router';
import Layout from './Components/Layout/LayoutComponent';
// import Reserve from './Components/Reserve/Index';
import AccountingListComponent from './Components/Accounting/AccountingListComponent';
import Kyousai from './Components/Kyousai/Index';
import Water from './Components/Water/Index';
import contractcheck from './Components/ContractCheck/Index';
import RemittanceLogCheck from './Components/RemittanceLogCheck/Index';
import DirectDebitCheck from './Components/DirectDebitCheck/Index';
import Minori from './Components/Minori/Index';
import RemittanceDetail from './Components/RemittanceDetail/Index';
import RentMoney from './Components/RentMoney/Index';

import Transfer from './Components/Transfer/Index';

import MonthlyMoney from './Components/MonthlyMoney/Index';
import ResponseData from './Components/ResponseData/Index';
import OwnerMail from './Components/OwnerMail/Index';
import CashTeller from './Components/CashTeller/Index';
import RentMoneyBulkInsert from './Components/RentMoneyBulkInsert/Index';

import OfficeContracts from './Components/OfficeContracts/Index';
import ContractsList from './Components/ContractsList/Index';
import ContractConfirm from './Components/ContractConfirm/Index';

// import DetailComponent from './Components/Detail/DetailComponent';
interface Props extends RouteComponentProps<{}> {
  // 他の型定義
}

const App: React.FC = () => {

  return (
    <Layout>

      <Route path='/Kyousai' component={Kyousai} />
      <Route path='/Water' component={Water} />
      <Route exact path='/Accounting' component={AccountingListComponent} />
      <Route exact path='/contractcheck' component={contractcheck} />
      <Route exact path='/RemittanceLogCheck' component={RemittanceLogCheck} />
      <Route exact path='/DirectDebitCheck' component={DirectDebitCheck} />
      <Route exact path='/Minori' component={Minori} />
      <Route exact path='/RemittanceDetail' component={RemittanceDetail} />
      <Route exact path='/RentMoney' component={RentMoney} />
      <Route exact path='/Transfer' component={Transfer} />
      <Route exact path='/MonthlyMoney' component={MonthlyMoney} />
      <Route exact path='/OwnerMail' component={OwnerMail} />
      <Route exact path='/RentMoneyBulkInsert' component={RentMoneyBulkInsert} />
      <Route exact path='/ResponseData' component={ResponseData} />
      <Route exact path='/CashTeller' component={CashTeller} />
      <Route exact path='/OfficeContracts' component={OfficeContracts} />
      <Route exact path='/ContractsList' component={ContractsList} />
      <Route exact path='/ContractConfirm' component={ContractConfirm} />
    </Layout>

  );
}
export default App;
